export class LineItemsModel {
    productId: string;
    dcmCode: string;
    socCode: string;
    quantity: number;
    email: string;
    bundleSkuId: string;
    isTncAccepted: boolean;
    childDcmCodes: string[];
    configurations: any[];

    constructor() {
        this.configurations = undefined;
        this.dcmCode = undefined;
        this.email = '';
        this.isTncAccepted = undefined;
        this.productId = undefined;
        this.quantity = undefined;
        this.socCode = undefined;
        this.bundleSkuId = undefined;
        this.childDcmCodes = undefined;
    }
}
